import { render, staticRenderFns } from "./ServicecalenderIndex.vue?vue&type=template&id=40ec5ed4&scoped=true"
import script from "./ServicecalenderIndex.vue?vue&type=script&lang=js"
export * from "./ServicecalenderIndex.vue?vue&type=script&lang=js"
import style0 from "./ServicecalenderIndex.vue?vue&type=style&index=0&id=40ec5ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ec5ed4",
  null
  
)

export default component.exports